export default __webpack_public_path__ + "static/media/tableup.6acc493e.svg";